import AuthLayout from "./AuthLayout";
import { useNavigate } from "react-router-dom";
import { Button, TextField } from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useFormik } from "formik";
import * as Yup from "yup";
import { usePostForgotPasswordMutation } from "../../service/auth";
import { showError, showToast } from "../../constants/toasts";
import Loader from "../../constants/Loader";
import { useState } from "react";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [forgetPasswordMutation] = usePostForgotPasswordMutation();
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .required("Email is required")
        .matches(
          /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
          "Please enter a valid email address"
        ),
    }),
    onSubmit: async (values: any) => {
      formik.setSubmitting(true);

      const body = {
        email: values.email,
      };

      try {
        setLoading(true);
        const response = await forgetPasswordMutation(body).unwrap();
        setLoading(false);
        if (response?.status === 200) {
          navigate("/otp", { state: { email: formik.values.email } });
          showToast("OTP sent successfully");
        } else {
          showError(response?.message || "");
        }
      } catch (error: any) {
        setLoading(false);
        showError(error?.data?.message || "");
        console.error(error);
      }
    },
  });

  return (
    <AuthLayout>
      <Loader isLoad={loading} />
      <div className="authBox">
        <h2>Forgot Password</h2>
        <p>Please enter email address</p>
        <form onSubmit={formik.handleSubmit}>
          <div className="control_group">
            <label>Email Address</label>
            <TextField
              placeholder="Enter Email Address"
              hiddenLabel
              id="email"
              name="email"
              className="text_field"
              fullWidth
              value={formik.values.email}
              onChange={(val) => {
                if (val.target.value === " " || val.target.value === ".") {
                } else {
                  formik.handleChange(val);
                }
              }}
              onBlur={formik.handleBlur}
              helperText={
                formik.touched.email && typeof formik.errors.email === "string"
                  ? formik.errors.email
                  : ""
              }
            />
          </div>
          <div className="form_btn">
            <Button
              className="btn btn_primary w_100"
              // onClick={() => navigate("/otp")}
              type="submit"
            >
              Submit
            </Button>
          </div>
        </form>
        <div className="auth_bottom">
          <p>
            <span className="link" onClick={() => navigate("/")}>
              <KeyboardBackspaceIcon /> Back to Login
            </span>
          </p>
        </div>
      </div>
    </AuthLayout>
  );
};

export default ForgotPassword;
